import React from 'react';
import ReactDOMServer from 'react-dom/server';

import { ClientIcon } from 'app/components/DetailsPages/shared/CommonGround/Icons';

import { IDrawer } from '../../../PublicationContent';
import './styled';
import {
  DataTypeClientIconContainer,
  DataTypeClientPillText,
  DataTypeClientPillWrapper,
} from './styled';

export const dataTypeClientContentModifier = (
  node: HTMLDivElement,
  setDrawer: React.Dispatch<React.SetStateAction<IDrawer>>
) => {
  node.querySelectorAll('[data-type="clients"], [data-type="client"]').forEach((client) => {
    const slug = client.getAttribute('data-slug');
    const name = client.textContent;
    const template = document.createElement('div');
    template.innerHTML = ReactDOMServer.renderToString(<DataTypeClientPill name={name || ''} />);

    template.firstChild.addEventListener('click', () => {
      setDrawer({ show: true, slug, type: 'clients' });
    });

    client.replaceWith(template.firstChild);
  });
};

interface DataTypeClientPillProps {
  name: string;
}

export const DataTypeClientPill = ({ name }: DataTypeClientPillProps) => {
  return (
    <DataTypeClientPillWrapper>
      <DataTypeClientIconContainer>
        <ClientIcon width={16} height={16} fill={'var(--color-data-client-foreground)'} />
      </DataTypeClientIconContainer>
      <DataTypeClientPillText>{name}</DataTypeClientPillText>
    </DataTypeClientPillWrapper>
  );
};
